import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppShell } from "@/layouts/AppShell";
import { RouteErrorFallback } from "@/components/ErrorBoundary";
import { HomePage } from "@/pages/HomePage";
import { LibraryPage } from "@/pages/LibraryPage";
import PluginEmbedPage from "@/pages/PluginEmbedPage";
import { CollectionsPage } from "@/pages/CollectionsPage";
import { CollectionPage } from "@/pages/CollectionPage";
import { ItemPage } from "@/pages/ItemPage";
import { PlayerPage } from "@/pages/PlayerPage";
import { RequestsPage } from "@/pages/RequestsPage";
import { AllRequestsPage } from "@/pages/AllRequestsPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { ApiDocsPage } from "@/pages/ApiDocsPage";
import { DeviceLinkPage } from "@/pages/DeviceLinkPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { UsersPage } from "@/pages/admin/UsersPage";
import { PluginsPage } from "@/pages/admin/PluginsPage";
import { JobsPage } from "@/pages/admin/JobsPage";
import { AdminSettingsPage } from "@/pages/admin/SettingsPage";
import { MetadataPage } from "@/pages/admin/MetadataPage";
import { PlaybackPage } from "@/pages/admin/PlaybackPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    errorElement: <RouteErrorFallback />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "libraries/:libraryId", element: <LibraryPage /> },
      { path: "apps/:pluginId/*", element: <PluginEmbedPage /> },
      { path: "collections", element: <CollectionsPage /> },
      { path: "collections/:collectionId", element: <CollectionPage /> },
      { path: "items/:itemId", element: <ItemPage /> },
      { path: "requests", element: <RequestsPage /> },
      { path: "requests/all", element: <AllRequestsPage /> },
      { path: "settings", element: <SettingsPage /> },
      { path: "api-docs", element: <ApiDocsPage /> },
      { path: "link", element: <DeviceLinkPage /> },
      {
        path: "admin",
        children: [
          { index: true, element: <Navigate to="users" replace /> },
          { path: "users", element: <UsersPage /> },
          { path: "plugins", element: <PluginsPage /> },
          { path: "jobs", element: <JobsPage /> },
          { path: "activity", element: <PlaybackPage /> },
          { path: "metadata", element: <MetadataPage /> },
          { path: "settings", element: <AdminSettingsPage /> },
        ],
      },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
  // Player is outside the shell — fullscreen
  { path: "play/:sessionId", element: <PlayerPage />, errorElement: <RouteErrorFallback /> },
]);
